import React, { useContext, useEffect, useState } from 'react'
import styles from "./popup.module.css";
import { AuthContext } from '../../../../contextAPI';
import add_logo from "../../../../assets/add.png";
import remove_logo from "../../../../assets/remove.png";

import Button from '../../../button';
import { notify } from '../../../toast';
import NewService from './newService';
import { GetServices, RemoveService } from '../../../../utils/services';
import InsideBounce from '../../../bounce/InsideBounce';

const Popup = (props) => {

    const Auth = useContext(AuthContext);
    const token = Auth.isLoggedIn ? Auth.authenticatedUser.token.access_token : null
    const [isLoading, setIsLoading] = useState(true)
    const [listData, setListData] = useState(null)

    // for selecting one service
    const [selectedService, setSelectedService] = useState({})
    const [isSelected, setIsSelected] = useState(false)
    const [newServiceMode, setNewServiceMode] = useState(false)
    const [isRemoved, setIsRemoved] = useState(false);

    const refreshServicesListHandler = (data) => {
        if(!data)return notify("Ivyko klaida", "error")
        setNewServiceMode(false)
        setListData(data);
    }

    useEffect(()=>{
        const fetchServices = async() => {
            try {
                const serviceList = await GetServices()

                if(!serviceList.status || !serviceList.data)
                    throw new Error(serviceList.message)

                setListData(serviceList.data.services || []);
                
                setIsLoading(false)

            } catch (error) {
                notify(error.message, "error")
                props.onClose()
            }
        }

        fetchServices()
    },[isRemoved])

    const onRemoveServiceHandler = async() => {
        if(!Auth.isLoggedIn)return notify("Prisijunkite ;)", "warning");
        
        try {
            const response = await RemoveService({
                service_id: selectedService._id,
                project_id: process.env.REACT_APP_PROJECT_ID,
                },token)
                
                if(!response.status)throw new Error(response.message)
                setIsRemoved(!isRemoved);
                setIsSelected(false)
    
        } catch (error) {
            setIsLoading(false);
            return notify(error.message, "error");
        }

    }

    const pickServiceHandler = (obj) => {
        setIsSelected(true)
        setSelectedService(obj)
    }

    const DataList = () => {

        return <>
            {
                isLoading ?
                <div className={styles.loading__}>
                    <InsideBounce bgColor="var(--white-color)" />
                </div>
                : 
                <div className={styles.list}>
                    
                    {   
                        listData && listData.length > 0 ?

                        <>

                        <h1 className={styles.info_h1}>Paslaugos</h1>
                        
                        {
                            listData.map(
                                (obj,index) => {

                                    return <div
                                        onClick={() => pickServiceHandler(obj)} 
                                        key={obj._id} 
                                        className={`${styles.item} ${obj._id === selectedService._id && styles.selected}`}
                                    >
                                        {/* <div><h2>{index + 1}</h2></div> */}
                                        <h2>{obj.service_name}</h2>
                                    </div>
                                }
                            )
                        }
                        </>
                        :
                        listData && 
                        <h2>Šiuo metu paslaugų neteikiame</h2>
                    }
                </div>
            }
        </>
    }


    return (
        <div className={styles.container}>
            <div className={styles.popup}>

                {   
                    !newServiceMode &&
                    <DataList />
                }

                {Auth.isLoggedIn && newServiceMode &&
                    <>
                        <NewService onRefreshServices={refreshServicesListHandler} />
                    </>
                }

            </div>

            { 
                !newServiceMode &&
                <div className={styles.controllers}>
                {
                    isSelected  && 
                    <div className={styles.submit_btn}>
                        <Button onClick={() => props.onSubmit(selectedService)}>
                            Pasirinkti
                        </Button>
                    </div>
                }
                {
                Auth.isLoggedIn &&
                    <>
                        {
                            isSelected? 
                            <img onClick={onRemoveServiceHandler} style={{ width:"40px", height:"40px", cursor:"pointer"}} src={remove_logo} alt='' />
                            :
                            <img onClick={()=>{setNewServiceMode(true)}} style={{ width:"40px", height:"40px", cursor:"pointer"}} src={add_logo} alt='' />
                        }
                    </>
                }
                </div>
            }

        </div>
    )
}

export default Popup